import Translate from '@components/atoms/Translate/Translate'
import Button from '@components/molecules/Button/Button'
import LightBox from '@components/molecules/LightBox/LightBox'
import {
  ERROR_FILE_FORMAT_INVALIDIMAGE,
  ERROR_FILE_FORMAT_NOIMAGE,
  ERROR_FILE_FORMAT_WRONGMIME,
  ERROR_FILE_SIZE,
} from '@config/constants'
import PropTypes from 'prop-types'

const UploadErrorLb = ({ errorType, meta, onClose, onRetry }) => {
  let translation

  const translationMapping = {
    [ERROR_FILE_SIZE]: 'tooLarge',
    [ERROR_FILE_FORMAT_WRONGMIME]: 'wrongMime',
    [ERROR_FILE_FORMAT_NOIMAGE]: 'noImage',
    [ERROR_FILE_FORMAT_INVALIDIMAGE]: 'invalidSubType',
  }

  const generateTranslationStr = (input) => [
    `steps.upload.error.file.${input}.title`,
    `steps.upload.error.file.${input}.description`,
  ]

  const translKey = translationMapping[errorType] || 'unknown'
  translation = generateTranslationStr(translKey)

  return (
    <LightBox
      title={<Translate str={translation[0]} />}
      body={<Translate str={translation[1]} vars={meta} />}
      buttons={
        <>
          <Button
            icon="upload"
            bg="dark"
            onClick={() => {
              onClose()
              onRetry()
            }}
          >
            <Translate str="steps.upload.error.retry" />
          </Button>
        </>
      }
      onClose={onClose}
    />
  )
}

UploadErrorLb.defaultProps = {}
UploadErrorLb.propTypes = {
  errorType: PropTypes.oneOf([
    ERROR_FILE_SIZE,
    ERROR_FILE_FORMAT_WRONGMIME,
    ERROR_FILE_FORMAT_NOIMAGE,
    ERROR_FILE_FORMAT_INVALIDIMAGE,
  ]).isRequired,
  meta: PropTypes.objectOf(PropTypes.any).isRequired,
  onClose: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
}

export default UploadErrorLb
